var News = {
  // btn01用のオブジェクト

  sliderLen: undefined,

  init:function () {
    this.setSlide();
    this.modal();
  },

  setSlide: function() {
    this.sliderLen = $('.p-news-layout-clm-01').length;
    for (var i = 0; i < this.sliderLen; i++) {
      var slideItemLen = $('.p-news-layout-clm-01').eq(i).find('.p-news-slider-for').find('li').length;
      this.apendDots(slideItemLen,i + 1);
    }
  },

  apendDots: function (i,eq) {
    var _nav = '.js-p-news-slider-nav-0' + eq;
    for (var j = 0; j < i; j++) {
      $(_nav).append('<li><div class="btn"></div></li>');
    }
    this.slider(i,eq);
  },

  slider: function(i,eq) {
    var _slide = '.js-p-news-slider-for-0' + eq;
    var _nav = '.js-p-news-slider-nav-0' + eq;

    this.setScrollbar($(_slide));
  },

  addClass: function() {
    $('.slick-slide').each(function(){
      if($(this).data('slick-index') === 0){
        $(this).addClass('grip');
      }
    });
  },

  setScrollbar: function(elm){
    elm.mCustomScrollbar({
      axis:"x",
      contentTouchScroll: true,
      advanced:{autoExpandHorizontalScroll:true}

    });
  },

  modal: function(){
    var _$btn = $('.js-p-news-modal-btn');
    var _src;
    var _this = this;
    _$btn.on('click',function(){
      _src = $(this).data('src');
      $(_this.setModalTemp(_src)).appendTo('body').fadeIn(200,function(){
        $('body').css({'overflow':'hidden'});
        _this.closeModal();
      });
    });
  },

  setModalTemp: function(_src) {
    var modalTemp = '<div class="c-modal-overlay">' +
                      '<div class="c-modal-wrapper">' +
                        '<div class="c-modal-inner">' +
                          '<div class="c-modal-contents">' +
                            '<div class="p-report-modal-inner">' +
                              '<a href="javascript:void(0)" id="js-p-news-modal-close-btn" class="js-p-news-modal-close-btn p-report-modal-close-btn"><img src="/assets/img/common/btn_close.png"></a>' +
                              '<div class="c-youtube-holder">' +
                                '<iframe width="420" height="315" src="https://www.youtube.com/embed/'+ _src +'?rel=0" frameborder="0" allowfullscreen></iframe>' +
                              '</div>' +
                            '</div>' +
                          '</div>' +
                        '</div>' +
                      '</div>' +
                    '</div>';
    return modalTemp;
  },

  closeModal: function(){
    var _$btn = $('#js-p-news-modal-close-btn');
    _$btn.on('click',function(){
      $('.c-modal-overlay').fadeOut(200,function(){
        $(this).remove();
        $('body').css({'overflow':'auto'});
      });
    });
  },

};



module.exports = News;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_news.js
// module id = 13
// module chunks = 0